import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadImagesOptions = {
  mutationConfig?: MutationConfig<typeof uploadImages>;
};

type UploadDocumentType = {
  image: File;
  projectId: string;
};

type UploadDocumentsType = {
  images: FileList;
  projectId: string;
};

export const uploadImage = ({ image, projectId }: UploadDocumentType) => {
  return extractData(api.projects({ id: projectId }).images.post({ image }));
};

const uploadImages = ({ images, projectId }: UploadDocumentsType) => {
  return extractData(api.projects({ id: projectId }).images.batch.post({ images }));
};

export const useUploadImage = ({ mutationConfig }: UploadImagesOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadImages,
  });
};
